// src/Components/Forms/Financement/Salam/Validation/Tab3.tsx
import React from 'react';
import { Box, Grid } from '@mui/material';
import ReadOnlyDocumentList from '../../../../ReadOnlyDocumentList';

interface Tab3Props {
  documents?: any[]; 
}

const Tab3: React.FC<Tab3Props> = ({ documents = [] }) => {
  return (
    <div className="tabItem">
      <Box fontStyle="inherit" className="border" width={'85%'} position={'absolute'}>
        <Grid item xs={12} md={12} lg={12}>
          <ReadOnlyDocumentList documents={documents} />
        </Grid>
      </Box>
    </div>
  );
};

export default Tab3;